import request from "@/utils/request";
import {computed, reactive, ref} from "vue";

export default function useLoadData (url, options = {}) {
    const data = ref(null)
    const response = ref(null)
    const error = ref(null)
    const isLoading = ref(false)

    const fetchData = async(config = {}) => {
        isLoading.value = true;

        try{
            const result = await request({
                url: config?.url || url,
                ...(Object.values(config).length > 0 ? config : options)
            })

            response.value = result
            data.value = result.data
        }
        catch(err){
          error.value = err;
        }
        finally {
          isLoading.value = false;
        }
    }

    return {fetchData, response, error, data, isLoading}
}

// const cacheMap = reactive(new Map());
//
// export const useFetchCache = (key, url, config) => {
//     const info = useLoadData(url, {skip: true, ...config})
//
//     const update = () => cacheMap.set(key, info.response.value)
//     const clear = () => cacheMap.set(key, undefined)
//
//     const fetch = async () => {
//         try{
//             await info.fetch();
//             update();
//         }
//         catch(err){
//             clear();
//         }
//     }
//
//     const response = computed(() => cacheMap.get(key))
//     const data = computed(() => response.value?.data)
//
//     if(response.value === null) fetch();
//
//     return { ...info, fetch, data, response, clear }
// }
